import {
  Box,
  Button,
  Drawer,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useForm } from "react-hook-form";
import { rem } from "assets/js/common";
import axios from "axios";
import React, { useEffect, useState } from "react";
import moment from "moment";
import ImageDrawer from "components/ui/image-drawer";
import { useDispatch } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import { useHistory, useParams } from "react-router-dom";
import AlertConfirm from "components/ui/alert-confirm";
import AlertComplete from "components/ui/alert-complete";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import _ from "lodash";
import { Cookies } from "react-cookie";
import KeyboardArrowDownTwoToneIcon from "@mui/icons-material/KeyboardArrowDownTwoTone";
import { loadAlert } from "redux/reducers/top";

const useStyles = makeStyles((theme) => ({
  comment: {
    "& .input-section": {
      padding: rem(30),
      //   "& .MuiTextField-root": {
      //     "& .MuiInputBase-root": {
      //       height: rem(310),
      //       "& input": {
      //         height: rem(310),
      //       },
      //     },
      //   },
      "& .img-list": {
        display: "flex",
        justifyContent: "flex-start",
        "& .img-item": {
          position: "relative",
          margin: `${rem(15)} ${rem(8)} 0 0`,
          width: rem(60),
          height: rem(60),
          display: "block",
          "& img": {
            width: rem(60),
            height: rem(60),
            borderRadius: rem(10),
            marginRight: rem(6),
          },
          "& .img-close": {
            position: "absolute",
            top: rem(-3),
            right: rem(-3),
            maxWidth: rem(20),
            maxHeight: rem(20),
            minWidth: "auto",
            "& img": {
              width: rem(20),
              height: rem(20),
              margin: 0,
            },
          },
        },
      },
      "& .bottom-wrap": {
        "& button": {
          marginTop: rem(15),
          "& img": {
            paddingRight: rem(5),
          },
          "& + button": {
            margin: `${rem(10)} 0 0 0`,
          },
        },
      },
    },
    "& .comment-cnt": {
      fontSize: rem(14),
      fontWeight: 700,
      color: `#8E8E8E`,
      padding: `${rem(20)} ${rem(30)} ${rem(15)}`,
      borderBottom: `1px solid #EEEEEE`,
    },
    "& .comment-list": {
      padding: `${rem(30)}`,
      "& .name": {
        fontWeight: 700,
      },
      "& .content": {
        paddingTop: rem(5),
        fontSize: rem(14),
        fontFamily:
          "'Malgun gothic','맑은고딕', Dotum, '돋움', arial, sans-serif",
      },
      "& .img": {
        paddingTop: rem(15),
        flex: 1,
        "& img": {
          width: rem(60),
          height: rem(60),
          borderRadius: rem(10),
          marginRight: rem(6),
        },
        "& .image-loader": {
          marginRight: rem(8),
          display: "inline-block",
          "&:before": {
            display: "none",
          },
        },
      },
      "& .bottom": {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        paddingTop: rem(20),
        fontSize: rem(12),
        color: "#8E8E8E",
        "& span": {
          fontSize: rem(13),
          fontWeight: 800,
        },
        "& .func-btn": {
          display: "flex",
          alignItems: "center",
          "& img": {
            width: rem(24),
            height: rem(24),
          },
          "& button": {
            minWidth: "auto",
            "& + button": {
              marginLeft: rem(15),
            },
          },
        },
      },
      "& +.comment-list": {
        borderTop: `1px solid #EEEEEE`,
      },
      "& .top": {
        display: "flex",
        justifyContent: "space-between",
        "& .textBtn": {
          "& button": {
            display: "inline-block",
            position: "relative",
            minWidth: "auto",
            fontWeight: "400",
            fontSize: rem(14),
            "& + button": {
              marginLeft: rem(10),
              paddingLeft: rem(10),
              "&:before": {
                top: "50%",
                left: 0,
                width: "1px",
                height: "50%",
                content: "''",
                position: "absolute",
                transform: "translateY(-50%)",
                backgroundColor: theme.palette.grey[100],
              },
            },
          },
        },
      },
    },
    "& .review-btn": {
      padding: `${rem(50)} ${rem(30)} ${rem(20)}`,
      "& .h2": {
        fontSize: rem(18),
        fontWeight: 800,
        marginBottom: rem(15),
      },
      "& .link-outlined": {
        width: "100%",
        height: rem(54),
        borderRadius: rem(10),
        fontSize: rem(14),
        fontWeight: 400,
        color: theme.palette.info.main,
        background: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[100]}`,
        paddingLeft: rem(20),
        textDecoration: "none",
        justifyContent: "flex-start",
      },
    },
    "& .func-wrap": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      padding: `${rem(20)} ${rem(30)} ${rem(12)} ${rem(30)}`,
      "& .cnt": {
        fontSize: rem(14),
        color: "#8E8E8E",
        fontWeight: 700,
      },
      "& .sort": { fontSize: rem(13) },
      "& .MuiSvgIcon-root": {
        display: "none",
      },
      "& .MuiButton-text": {
        fontSize: rem(13),
        minWidth: "auto",
        "&:after": {
          content: "''",
          width: rem(18),
          height: rem(18),
          backgroundImage: `url(${
            process.env.PUBLIC_URL
          }/images/icon/arrow-selectbox.svg)`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        },
      },
    },
  },
}));

const cookies = new Cookies();

export default function ReviewComment(props) {
  let { buyYn } = props;
  // const [no, setNo] = useState("");
  const no = cookies.get("no");
  const token = cookies.get("X-AUTH-TOKEN");
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const { seq } = useParams();

  const {
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      pdSeq: "",
      cont: "",
      imgUrl1: "",
      imgUrl2: "",
      imgUrl3: "",
    },
  });

  const [initialized, setInitialized] = useState(true);
  const [open, setOpen] = useState(false);
  const [alertMode, setAlertMode] = useState("");
  const [seletedItem, setSeletedItem] = useState("");
  const [rows, setRows] = useState({
    list: [],
    totalPageSize: 0,
  });
  const [sordFld, setSordFld] = useState("rgstDesc");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState("rgstDesc");
  const [schForm, setSchForm] = useState({
    pg: 1,
    pgSz: 10,
    pdSeq: seq,
  });
  const [reviewList, setReviewList] = useState({ list: [] });

  useEffect(() => {
    setValue("pdSeq", seq);
    loadReviewList(schForm);
  }, []);

  const loadReviewList = (form) => {
    axios
      .get(`/api/eh/product-review`, {
        params: { ...form },
      })
      .then((res) => {
        setReviewList(res.data.data.productReviewList);
      });
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const handleInfiniteScroll = () => {
    console.log("handleInfiniteScroll");
    if (schForm.pg >= rows.totalPageSize) {
      setInitialized(false);
      return;
    }

    loadReviewList({ pg: schForm.pg + 1, pgSz: 10, pdSeq: seq });
    setSchForm({
      ...schForm,
      pg: schForm.pg + 1,
      pgSz: 10,
    });
  };

  const init = () => {
    setRows({
      ...rows,
      list: [],
    });
    loadReviewList({
      ...schForm,
      pg: 1,
    });
    setValue("cont", "");
  };

  const handleDelete = () => {
    axios
      .post("/api/eh/product-review/remove", null, {
        params: {
          seq: seletedItem.seq,
        },
      })
      .then((res) => {
        handleAlertClose();
        loadReviewList({
          ...schForm,
          pg: 1,
        });
        setSchForm({
          ...schForm,
          pg: 1,
        });
      });
  };

  watch("cont", false);
  watch("imgUrls", false);

  const handleFav = (item, i) => {
    console.log("i", i);
    axios
      .post("/api/eh/product-review/like", {
        seq: item.seq,
      })
      .then((res) => {
        // init();
        let data = res.data.data;
        item = {
          ...item,
          favCnt: data == "Y" ? item.favCnt + 1 : item.favCnt - 1,
          favYn: data,
        };
        const ll = [...rows.list];
        ll.splice(i, 1, item);
        setRows({
          ...rows,
          list: ll,
        });
      });
    console.log("rows", rows.list);
  };

  const handleAlertOpen = (mode) => {
    setAlertMode(mode);
    setOpen(true);
  };

  const handleAction = (item, i) => {
    setSeletedItem({
      ...item,
      i: i,
    });
    handleAlertOpen("delConfirm");
  };
  const checkAlertType = (item, i) => {
    handleAlertOpen(item.rptYn == "Y" ? "cancelConfirm" : "reportConfirm");

    setSeletedItem({
      ...item,
      i: i,
    });
  };
  const handleRpt = () => {
    setOpen(false);
    axios
      .post("/api/eh/product-review/report", {
        seq: seletedItem.seq,
      })
      .then((res) => {
        let data = res.data.data;
        if (data == "Y") {
          handleAlertOpen("reportComp");
        }

        let item = {
          ...seletedItem,
          rptCnt: data == "Y" ? seletedItem.rptCnt + 1 : seletedItem.rptCnt - 1,
          rptYn: data,
        };
        const ll = [...rows.list];
        ll.splice(seletedItem.i, 1, item);
        setRows({
          ...rows,
          list: ll,
        });
      });
  };

  useEffect(() => {
    console.log("seq: ", seq);
    if (reviewList && reviewList.list.length > 0) {
      if (schForm.pg == "1") {
        setRows({
          ...reviewList,
        });
      } else {
        setRows({ ...reviewList, list: [...rows.list, ...reviewList.list] });
      }
    }
  }, [reviewList]);

  useEffect(() => {
    if (drawerOpen === true) setDrawerData(sordFld);
  }, [drawerOpen]);

  const moveToReview = () => {
    if (token) {
      if (buyYn == "Y") history.push("/my-review");
      else handleAlertOpen("notBuying");
    } else {
      dispatch(loadAlert(true));
    }
  };

  return (
    <div className={classes.comment + " fav-comment"}>
      <div className="review-btn bg-grey">
        <h2 className="h2">고객리뷰</h2>
        {/* <Link to={"/my-review"} className="link-outlined">
          이 상품 어떠세요? 리뷰를 남겨주세요!
        </Link> */}
        <Button
          className="link-outlined"
          onClick={() => {
            moveToReview();
          }}
        >
          이 상품 어떠세요? 리뷰를 남겨주세요!
        </Button>
      </div>

      <Box pb={7} className="bg-grey">
        {/* {loadingCmt && rows.list.length == 0 ? (
            <div className="board-list">
              {Array.from(Array(6)).map((_, index) => (
                <div className="item" key={index}>
                  <Box p={6} pt={0}>
                    <Skeleton height={30} />
                    <Skeleton height={30} width={100} />
                  </Box>
                </div>
              ))}
            </div>
          ) : */}
        {
          <>
            {rows.list.length > 0 && (
              <InfiniteScroll
                dataLength={rows.list.length}
                next={handleInfiniteScroll}
                hasMore={setInitialized}
                inverse={false}
              >
                <div className="func-wrap">
                  <div className="cnt">리뷰 {rows.totalSize}개</div>
                  <div className="sort">
                    <Button
                      onClick={() => {
                        setDrawerOpen(true);
                      }}
                      className="fontN"
                    >
                      {sordFld == "rgstDesc"
                        ? "최신 순"
                        : sordFld == "rgstAsc"
                        ? "오래된 순"
                        : "베스트 순"}
                      <KeyboardArrowDownTwoToneIcon />
                    </Button>
                  </div>
                </div>
                <ul>
                  {rows.list.map((item, i) => (
                    <li className="comment-list" key={i}>
                      <div className="top">
                        <div className="name">{item.mbrNm}</div>
                        {item.mbrNo == no && (
                          <div className="textBtn">
                            {/* <Button
                                size="small"
                                color="info"
                                onClick={() => handleDrawerOpen(item, i)}
                              >
                                수정
                              </Button> */}
                            <Button
                              size="small"
                              color="info"
                              onClick={() => handleAction(item)}
                            >
                              삭제
                            </Button>
                          </div>
                        )}
                      </div>

                      <div className="content">{item.cont}</div>
                      <div className="img">
                        <ImageDrawer item={item} />
                      </div>
                      <div className="bottom">
                        <div className="date">
                          {moment(item.rgstYmd).format("YYYY.MM.DD(ddd)")}
                        </div>
                        <div className="func-btn">
                          <Button
                            className="report"
                            onClick={() => {
                              if (token) checkAlertType(item, i);
                              else dispatch(loadAlert(true));
                            }}
                          >
                            <img
                              src={`${
                                process.env.PUBLIC_URL
                              }/images/icon/report${
                                item.rptYn == "Y" ? "-on" : "-off"
                              }.svg`}
                            />
                            <span
                              style={{
                                color:
                                  item.rptYn == "Y" ? "#000000" : "#CCCCCC",
                              }}
                            >
                              {item.rptCnt}
                            </span>
                          </Button>
                          <Button
                            className="fav"
                            onClick={() => {
                              if (token) handleFav(item, i);
                              else dispatch(loadAlert(true));
                            }}
                          >
                            <img
                              src={`${
                                process.env.PUBLIC_URL
                              }/images/icon/favorite${
                                item.favYn == "Y" ? "" : "-off"
                              }.svg`}
                            />
                            <span
                              style={{
                                color:
                                  item.favYn == "Y" ? "#F1270B" : "#CCCCCC",
                              }}
                            >
                              {item.favCnt}
                            </span>
                          </Button>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </InfiniteScroll>
            )}
          </>
        }
      </Box>
      {alertMode == "reportComp" ? (
        <>
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={"신고가 완료되었습니다."}
            action={handleAlertClose}
          />
        </>
      ) : alertMode == "reportConfirm" ? (
        <AlertConfirm
          open={open}
          handleAlertClose={handleAlertClose}
          text={"해당 리뷰를 신고하시겠습니까?"}
          action={() => {
            handleRpt();
          }}
        />
      ) : alertMode == "delConfirm" ? (
        <AlertConfirm
          open={open}
          handleAlertClose={handleAlertClose}
          text={"해당 리뷰를 삭제하시겠습니까?"}
          action={() => {
            handleDelete();
          }}
        />
      ) : alertMode == "notBuying" ? (
        <AlertComplete
          open={open}
          handleAlertClose={handleAlertClose}
          text={"본 상품 구매 후 작성 가능합니다. "}
          action={handleAlertClose}
        />
      ) : (
        <AlertConfirm
          open={open}
          handleAlertClose={handleAlertClose}
          text={"해당 리뷰의 신고를 취소하시겠습니까?"}
          action={() => {
            handleRpt();
          }}
        />
      )}

      {/* ST : Drawer-row */}
      <Drawer
        anchor="bottom"
        open={drawerOpen}
        onClose={() => {
          setDrawerOpen(false);
        }}
        className="drawer-common-bottom size-small"
      >
        <div className="drawer-head">
          <h3>정렬 기준</h3>
          <IconButton
            aria-label="close"
            className="btn-close"
            onClick={() => {
              setDrawerOpen(false);
            }}
          >
            <span className="hidden">닫기</span>
          </IconButton>
        </div>

        <div className="drawer-body">
          <Box className="box-type-10">
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={drawerData}
              value={drawerData}
              name="radio-buttons-group"
              onChange={(e) => {
                console.log("e.target.value: ", e.target.value);
                setDrawerData(e.target.value);
              }}
            >
              <FormControlLabel
                value="rgstDesc"
                control={
                  <Radio
                    color="primary"
                    icon={<span className="radio-icon" />}
                    checkedIcon={<span className="radio-icon-checked" />}
                    className="mgR15"
                  />
                }
                label="최신 순"
              />
              <FormControlLabel
                value="rgstAsc"
                control={
                  <Radio
                    color="primary"
                    icon={<span className="radio-icon" />}
                    checkedIcon={<span className="radio-icon-checked" />}
                    className="mgR15"
                  />
                }
                label="오래된 순"
              />
              <FormControlLabel
                value="best"
                control={
                  <Radio
                    color="primary"
                    icon={<span className="radio-icon" />}
                    checkedIcon={<span className="radio-icon-checked" />}
                    className="mgR15"
                  />
                }
                label="베스트 순"
              />
            </RadioGroup>
          </Box>
        </div>
        <div className="drawer-foot">
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              setSordFld(drawerData);
              console.log("drawerData: ", drawerData);
              loadReviewList({
                pg: 1,
                pgSz: 10,
                pdSeq: seq,
                sordFld: drawerData,
              });
              setSchForm({
                pg: 1,
                pgSz: 10,
                pdSeq: seq,
                sordFld: drawerData,
              });
              setDrawerOpen(false);
            }}
          >
            선택완료
          </Button>
        </div>
      </Drawer>
      {/* EN : Drawer-row */}
    </div>
  );
}
